import { createFileRoute } from '@tanstack/react-router';

import {
    scratchpadDetailSearchSchema,
    ScratchpadNoteDetailPage,
} from '@apps/web/features/admin_agent_scratchpad';

export const Route = createFileRoute('/_app/admin/agent/scratchpad/$note-id')({
    component: ScratchpadNoteDetailRoute,
    validateSearch: scratchpadDetailSearchSchema,
    head: () => ({
        meta: [{ title: 'Scratchpad Note | Phoebe Admin' }],
    }),
});

function ScratchpadNoteDetailRoute() {
    const params = Route.useParams();
    const search = Route.useSearch();
    return (
        <ScratchpadNoteDetailPage noteId={params['note-id']} search={search} />
    );
}
